import styled, { css } from 'styled-components'

import { breakpoints } from '@/styles/breakpoints'
import { customColor } from '@/styles/custom-color'

export const Content = styled.div`
  display: flex;
  padding: 0 32px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  flex: 1 0 0;
  align-self: stretch;
`

export const Header = styled.div`
  display: flex;
  padding: 0 32px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;

  p {
    color: ${customColor.black1};
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px;
  }
`

export const Footnote = styled.div`
  color: ${customColor.gray1};
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`

export const Footer = styled.div`
  display: flex;
  padding: 32px;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

const ContainerForMobile = css`
  padding-top: 24px;
  justify-content: center;
  min-height: 686px;

  ${Header} {
    padding: 0;

    p {
      font-size: 20px;
      line-height: 28px;
    }
  }

  ${Footnote} {
    font-size: 14px;
    line-height: 20px;
  }

  ${Footer} {
    padding: 24px;
    flex-direction: column;
    align-self: center;
    gap: 8px;
  }
`

export const Container = styled.div`
  display: flex;
  min-height: 570px;
  padding-top: 32px;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${breakpoints.xmMinWidth}) {
    ${ContainerForMobile}
  }
`
